import {
  Control,
  Grouping,
  Language,
  Navigator,
  Service,
} from '@yleisradio/areena-types';
import { Query } from 'types/query';
import { getCanonicalBaseURL, getCanonicalURL } from 'utils/url';
import { shortcutData } from './shortcutApiData';

const getShortcutControls = (
  lang: Language,
  currentPath: string,
  query: Query,
  service: Service
): Control[] => {
  const resolveActivators = (control: Control) => {
    const otherLang: Language = lang === 'fi' ? 'sv' : 'fi';
    const languageChangeUrl =
      getCanonicalURL(currentPath, otherLang, query) ||
      getCanonicalBaseURL(otherLang);

    if (
      control.type === 'activator' &&
      control.functionality &&
      control.functionality.id === 'languageChange'
    ) {
      return {
        ...control,
        destination: {
          uri: languageChangeUrl,
        },
        type: 'navigator',
      } satisfies Navigator;
    }
    return control;
  };

  return shortcutData[service][lang].map(resolveActivators);
};

export const shortcutsGrouping = (
  lang: Language,
  currentPath: string,
  query: Query,
  service: Service
): Grouping => ({
  controls: getShortcutControls(lang, currentPath, query, service),
  groupings: [],
  tag: 'shortcuts',
  type: 'grouping',
});
